import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Layout from '../components/Layout'
import Header from '../components/Header'
import Takmicenje from '../img/takmicenje.jpg'

const Nagradna = () => (
  <Layout>
    <Header>Video takmičenje</Header>
    <section className="section">
    <div className="container">
      <div className="container-pages" style={{ border: 'none' }}>   
        <div className="text-promo-header">
          <h4 className="text-promo-large">
            Učestvuj u video takmičenju „Furaj svoj film“
          </h4>
        </div>            
        <div className="promo-row">
          <div className="text-promo">
          <img className="image-mobile-full" src={Takmicenje} />
            <p className="text-promo-normal"></p>
          	<p className="text-promo-normal">Učestvuj u video takmičenju „Furaj svoj film“ i osvoji vrijedne nagrade!</p>
            <p className="text-promo-normal">Takmičenje traje od 16. do 28. avgusta 2019.</p>
            <p className="text-promo-normal">Snimite kreativni video u trajanju do 1 minute u kojem ćete prikazati najljepše djelove Sarajeva, dešavanja sa Sarajevo Film Festivala ili druge znamenitosti glavnog grada.</p>
            <p className="text-promo-normal">Video uploadujete u aplikaciju na <a href="http://www.furajsvojfilm.ba/">www.furajsvojfilm.ba</a>.</p>
            <p className="text-promo-normal">Svaki dan imate priliku osvojiti jednu glavnu i dvije utješne nagrade.</p>
            <p className="text-promo-normal">Nagradni fond i pravila takmičenja „Furaj svoj film“ pogledajte <a href="https://bhtelecom.ba/fileadmin/assets/pdfs/Foto_takmicenje_pravila_furaj_svoj_film.pdf">ovdje</a>.</p>
            <p className="text-promo-normal">Furajte svoj film, zabavite se, vrijedne nagrade vas čekaju svakoga dana!</p>
          </div>        
        </div>
      </div>
    </div>
    </section>
  </Layout>
)

export default Nagradna